export default {
    getUnreadSystemMsgsSuccess: 'getUnreadSystemMsgsSuccess',
};